module.exports = __webpack_public_path__ + "img/Inflammation-BRME_GSE179572.f4a00a9e.png";